import React from 'react';
import { MultiSelect, Option } from '../../../../components/ui/multi-select';
import { CollapsibleFilterBar } from '../../../project/components/dashboard/materials/tabs/Filters/CollapsibleFilterBar';
import type { UserFilters } from '../../types/user';

const STATUS_OPTIONS: Option[] = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'pending', label: 'Pending' },
  { value: 'suspended', label: 'Suspended' },
];

const ROLE_OPTIONS: Option[] = [
  { value: 'user', label: 'User' },
  { value: 'admin', label: 'Admin' },
  { value: 'manager', label: 'Manager' },
  { value: 'viewer', label: 'Viewer' },
  { value: 'super_admin', label: 'Super Admin' },
];

interface UserManagementFiltersProps {
  filters: UserFilters;
  onFiltersChange: (filters: UserFilters) => void;
  departmentOptions: Option[];
  companyOptions: Option[];
  categoriesLoading?: boolean;
  filteredCount?: number;
}

export const UserManagementFilters: React.FC<UserManagementFiltersProps> = ({
  filters,
  onFiltersChange,
  departmentOptions,
  companyOptions,
  categoriesLoading = false,
  filteredCount,
}) => {
  const handleMultiSelectChange =
    (field: keyof UserFilters) => (value: string[]) => {
      onFiltersChange({
        ...filters,
        [field]: value.length > 0 ? value : undefined,
      });
    };

  const handleResetFilters = () => {
    onFiltersChange({});
  };

  const activeFilterCount =
    (filters.status?.length ?? 0) +
    (filters.roles?.length ?? 0) +
    (filters.department?.length ?? 0) +
    (filters.company?.length ?? 0);

  return (
    <CollapsibleFilterBar
      searchQuery={filters.search || ''}
      onSearchChange={(value) =>
        onFiltersChange({
          ...filters,
          search: value || undefined,
        })
      }
      searchPlaceholder="Search by name, email, department, or company..."
      activeFilterCount={activeFilterCount}
      filteredCount={filteredCount}
      filteredCountLabel="users"
      onResetFilters={handleResetFilters}
    >
      <MultiSelect
        options={STATUS_OPTIONS}
        selected={filters.status || []}
        onChange={handleMultiSelectChange('status')}
        placeholder="Status"
        isSearchable={false}
      />
      <MultiSelect
        options={ROLE_OPTIONS}
        selected={filters.roles || []}
        onChange={handleMultiSelectChange('roles')}
        placeholder="Role"
        isSearchable={false}
      />
      <MultiSelect
        options={departmentOptions}
        selected={filters.department || []}
        onChange={handleMultiSelectChange('department')}
        placeholder={categoriesLoading ? 'Loading...' : 'Department'}
        isSearchable
      />
      <MultiSelect
        options={companyOptions}
        selected={filters.company || []}
        onChange={handleMultiSelectChange('company')}
        placeholder={categoriesLoading ? 'Loading...' : 'Company'}
        isSearchable
      />
    </CollapsibleFilterBar>
  );
};
